import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#clip0_8260_202213)\"><path d=\"M3.33398 11.8333C11.334 11.8333 7.33398 2.5 15.334 2.5\" stroke=\"#FDBD00\" stroke-width=\"2\" stroke-miterlimit=\"10\" stroke-linecap=\"square\"></path><path d=\"M15.3337 14.5H0.666992V2.5\" stroke=\"#FDBD00\" stroke-width=\"2\" stroke-miterlimit=\"10\" stroke-linecap=\"square\"></path></g><defs><clipPath id=\"clip0_8260_202213\"><rect width=\"16\" height=\"16\" fill=\"white\" transform=\"translate(0 0.5)\"></rect></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }